import { Flex, FlexProps } from '@mantine/core';
import { MotionProps, motion } from 'framer-motion';

export const MFlex = motion.create<FlexProps>(Flex);
export interface MFlexProps extends Omit<FlexProps, keyof MotionProps>, MotionProps {}
